import { Routes } from '@angular/router';
import { environment } from '../environments/environment';

const developmentFeatureRoutes: Routes = [
  {
    path: 'contacts',
    loadChildren: () => import('./features/contacts/contacts.routes'),
    data: { tab: 'Contacts' },
  },
  {
    path: 'inventory',
    loadComponent: () => import('./features/inventory/inventory.component').then((m) => m.InventoryComponent),
    data: { tab: 'Inventory' },
  },
];

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
        data: { tab: 'Home' },
      },
      {
        path: 'jobs',
        loadChildren: () => import('./features/jobs/jobs.routes'),
        data: { tab: 'Jobs' },
      },
      {
        path: 'forecast',
        loadChildren: () => import('./features/forecast/forecast.routes'),
        data: { tab: 'Forecast' },
      },
      {
        path: 'profiles',
        loadChildren: () => import('./features/profiles/profiles.routes'),
        data: { tab: 'Profiles' },
      },
      {
        path: 'validity',
        loadComponent: () => import('./features/validity/validity.component').then((m) => m.ValidityComponent),
        data: { tab: 'Validity' },
      },
      ...(environment.properties.app.developmentFeatureRoutesEnabled ? developmentFeatureRoutes : []),
      {
        path: '**',
        loadComponent: () => import('./features/not-found/not-found.component').then((m) => m.NotFoundComponent),
      },
    ],
  },
];
